import './App.css';
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import mainReducer from './Reducers/MainReducer';
//import Provider from '@react/react-spectrum/Provider';
import {
    BrowserRouter as Router,
    Redirect,
    Switch,
    Route
} from "react-router-dom";
import PageHeader from "./components/headers/PageHeader"
import Home from './pages/Home'
import Uploading from "./components/Uploading"
import ActionPg from "./pages/ActionPg"
import React from "react";
import CSSUtil from './utils/CSSUtil';
import {quickActionType,quickAction} from './constants';

export const store = createStore(mainReducer);
export default class App extends React.Component {
    componentDidMount() {
        CSSUtil.hideTransitionLoader();
    }

    render() {
        return (
        <Provider store={store}>
        <div className="quickActionsWrapper">
                <Switch>
                    <Route exact path='/quick-actions'>
                        <Redirect to="/quick-actions/pattern" />
                    </Route>
                    <Route exact path='/quick-actions/:buttonAction'
                        render={(props) => {
                            if (quickActionType[props.match.params.buttonAction.toUpperCase()]){
                               return <ActionPg {...props} {...this.props} />
                            }
                            else {
                                return  <Redirect to="/quick-actions/pattern" />
                            }                           
                        }                        
                    }
                    />
                    <Route exact path='/quick-actions/:buttonAction/make'
                            render={(props) => {
                            if (quickActionType[props.match.params.buttonAction.toUpperCase()]){
                                return <Uploading {...props} {...this.props} />
                            }
                            else { 
                                return <Redirect to="/quick-actions/pattern" />
                            }
                        }
                    }
                    />
                </Switch>
        </div>
        </Provider>)
    }
}